import { formatDate, formatDateISO } from '@helpers/date';
import { imageUrl } from '@helpers/image';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import SvgFallback from '@img/logos/nav-card-fallback.svg';
import * as React from 'react';
import S from './NavigationCard.styles';
const NavigationCard = (props) => {
    return (React.createElement(S.Container, { "data-image": !!props.image },
        React.createElement(S.Link, { href: props.url },
            props.image ? (React.createElement(S.Image, { alt: props.image.altText, loading: "lazy", src: imageUrl(props.image, {}) })) : (React.createElement(S.FallbackImage, null,
                React.createElement(SvgFallback, null))),
            React.createElement(S.ContentWrapper, null,
                props.date && (React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'd MMM ‘yy'))),
                props.tag && (React.createElement(S.Tag, { style: {
                        '--accentColor': props.tag.bgColor,
                        '--fgColor': props.tag.fgColor,
                    } }, props.tag.text)),
                React.createElement(S.Title, null, props.title),
                props.linkText && (React.createElement(S.FakeCta, null,
                    React.createElement("span", null, props.linkText),
                    React.createElement(SvgArrowRight, null)))))));
};
export default NavigationCard;
